import { Box } from "@mui/material";
import Logo from "../assets/images/fitc/fitcHeader.png";

function EurekaHeader() {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          boxShadow: "none",
          padding: "1rem 1rem 3rem 1rem",
        }}>
        <img
          style={{
            width: "35%",
            maxWidth: 192,
            minWidth: 128,
            objectFit: "contain",
            cursor: "pointer",
          }}
          src={Logo}
          alt=" FITC Header"
          onClick={() => {
            window.location.replace('https://farminthecity.my');
          }}
        />
      </Box>
    </>
  );
}

export default EurekaHeader;
